<template>
    <!-- <loading v-if="loading"></loading> -->
    <div class="youxi">
        <div class="release" v-loading="loading" element-loading-text="拼命加载中">
            <div v-if="list.length>0">
                <forumComment @commentLove="commentLove" :operation="false" v-for="(item,index) in list" :item="item" :key="index" @goDetails="goDetails" @del="del"></forumComment>
            </div>
            <noData v-if="noData&&!loading"></noData>
            <p v-if="noMore && !noData">已经到底了~</p>
        </div>
    </div>
</template>
<script>
import forumComment from '@/components/forum-comment/index.vue'
import request from "@/utils/request";
import {diffTime} from '@/utils/common.js';
import loading from '@/components/loading/loading.vue'
import noData from '@/components/noData/index.vue'
import Cookies from 'js-cookie'
export default {
    components: {forumComment,loading,noData},
    data(){
        return{
            noData:false,
            loading:true,
            list:[],
            total:0,
            query:{
                page:1,
                limit:10,
                user_id:JSON.parse(localStorage.getItem('userInfo')).id
            },
            noMore:false,
        }
    },
    created(){
        if(Cookies.get('Admin-Token')){
            this.getList()
        }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);  // 监听（绑定）滚轮滚动事件
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);   //  离开页面清除（移除）滚轮滚动事件
    },
    methods:{
        handleScroll() {
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
               //滚动条到底部的条件
            if(scrollTop+windowHeight==scrollHeight){
                if(!this.noMore){
                    console.log('触底')
                    this.query.limit += 10
                    this.getList()
                }
                //写后台加载数据的函数
                // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            }          
        },
        goDetails(id){
            this.$router.push(
                {
                    path:"/forum/forumDetails",
                    query:{
                        forum_post_id:id
                    }
                }
            )
        },
         // 评论点赞
        commentLove(id) {
            request({
                url: "/api/userend/post/commentLike",
                method: "post",
                params: {forum_post_message_id:id}
            }).then(response => {
                let index = this.list.findIndex(item=>{
                    return item.id==id
                })
                this.list[index].is_like=!this.list[index].is_like
                if(this.list[index].is_like==0){
                    this.list[index].like_num-=1
                }else{
                    this.list[index].like_num+=1
                }
            });
        },
        // 我的评论
        getList() {
			this.loading=true
            request({
                url: "/api/userend/post/userAllComment",
                method: "get",
                params: this.query
            }).then(response => {
                response.data.forEach((item,index) => {
                    item.dateTime=diffTime(item.created_at)
                });
                this.list = response.data;
                this.total=response.data.length
                if(this.total==0){
                    this.noData=true
                }
                if(this.list.length < this.query.limit){
                    this.noMore=true
                }
                this.loading=false
            });
        },
        // 删除
        del(id){
            this.$confirm('此操作将永久删除帖子, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //点击确定的操作(调用接口)
                request({
                    url: "/api/userend/post/removeComment",
                    method: "post",
                    params: {forum_post_message_id:id}
                }).then(response => {
                    this.$message.success("删除成功")
                    this.getList()
                });
            }).catch(() => {
                //几点取消的提示
            });
        }
    }
}
</script>
<style lang="scss">
.youxi{
    .pagination-container{
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
  }
    .height4{
        height: 100vh;
    }
    .release{
        background: #ffffff;
        padding: 0 30px;
        border-radius: 8px;
        p{
            text-align: center;
            padding: 5px 0 15px 15px;
        }
    }
    .el-loading-spinner{
        position: fixed;
        top: 400px;
        left: 230px;
    }
}

</style>